import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../types'
import { CmsConverterService, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class LegalBoxConverter extends CmsConverterService<LegalBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_text ?? defaultTextInput,
      backgroundColor: 'bg-' + (formData?.st_backgroundcolor?.value?.identifier ?? 'white'),
    }
  }
}

export const LEGAL_BOX_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, LegalBoxData>>('LegalBoxConverter')

export interface LegalBoxData extends ConvertedComponentData {
  text: TextInput;
  backgroundColor: string;
}
